import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';

export const getCarrierTabNavigationProps = originExchangeOfficesData => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
    mainReportId: ReportDefinitions.CARDIT_NESTING_CARRIER.id,
    requestParams: {
      carrierCode: rowInfo.row['carrier'], // eslint-disable-line
      originExchangeOffices: originExchangeOfficesData.originExchangeOffices,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.CARDIT_NESTING_DETAILS.id,
    ],
  } : {}
);

export default (data, originExchangeOfficesData) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Carrier', 'carrier').withTotalHeader('Total', 'bg-total-grey'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationWithFooterColumn(new NonZeroNumberColumn('Total', 'receptacles.total').withTotalHeader(sumTotal, 'bg-total-grey'), getCarrierTabNavigationProps(originExchangeOfficesData)),
        new NonZeroNumberColumn('CJID nested', 'receptacles.cjidNested').withShow(false),
        new NonZeroNumberColumn('ULD ID nested', 'receptacles.uldIdnested').withShow(false),
        new NonZeroPercentageColumn('% CJID nested', 'receptacles.pctCjidNested').withTotalHeader(totalRowRatio(['receptacles.cjidNested', 'receptacles.total']), 'bg-total-grey'),
        new NonZeroPercentageColumn('% ULD ID nested', 'receptacles.pctUldIdNested').withTotalHeader(totalRowRatio(['receptacles.uldIdnested', 'receptacles.total']), 'bg-total-grey'),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
        mainReportId: ReportDefinitions.CARDIT_NESTING_CARRIER.id,
        requestParams: {
          isTotal: true,
          carrierCode: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
